import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        classifiers: '=',
        occurrence: '=',
        versions: '='
    },
    template: `
        <form ng-submit="vm.applyFilter()">
            <div class="row">
                <label class="label">{{ 'filter.Name' | translate }}</label>
                <div class="items">
                    <input ng-model="vm.filter.name" type="text" class="form-control">
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Department' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.departmentId"
                        ng-options="item.id as item.value for item in vm.departments">
                    <option value=""></option>
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Role' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.roleId"
                        ng-options="item.id as item.value for item in vm.roles">
                    <option value=""></option>
                </select>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Level' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.levelId"
                        ng-options="item.id as item.value for item in vm.levels">
                    <option value=""></option>
                </select>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Status' | translate }}</label>
                <div class="items">
                    <div
                        ng-dropdown-multiselect=""
                        options="vm.multiFilter.statuses.options"
                        selected-model="vm.multiFilter.statuses.model"
                        extra-settings="vm.multiFilter.statuses.settings"
                        translation-texts="vm.filterTranslations">
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Display only employees without a personal deadline' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.withoutDeadline">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row separated">
                <label class="label">{{ 'filter.Only direct managers' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.isOnlyDirectManagers">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <label class="label">{{ 'filter.Previously completed' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input type="checkbox" name="switch" ng-model="vm.filter.previouslyCompleted" ng-change="vm.onPreviouslyCompletedChange()">
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <div class="row" ng-if="vm.filter.previouslyCompleted">
                <label class="label">{{ 'filter.Completed version' | translate }}</label>
                <div class="items">
                    <select class="form-control" ng-model="vm.filter.completedVersionId"
                        ng-options="version.id as version.name for version in vm.versions">
                    <option value=""></option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="items">
                     <a class="btn main small" ng-disabled="vm.list.loading" ng-click="vm.applyFilter()">{{ 'general.Search' | translate }}</a>
                </div>
            </div>
        </form>
    `
})
export default class {
    constructor (lodash, UserService, FilterService, CLASSIFIER_ENUM, USER_STATUS_ENUM, ROLE_CODE_ENUM) {
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.UserService = UserService;
        this.FilterService = FilterService;
    }

    $onInit () {
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        this.filter = {
            siteId: this.occurrence.siteId,
            occurrenceId: this.occurrence.id,
            includeExcludedTargets: true
        };
        this.filterTranslations = this.FilterService.getTranslations();
        this.initMultiFilter();
        this.applyFilter();
    }

    initMultiFilter () {
        this.multiFilterOptions = {
            statuses: [
                { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
                { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
            ]
        };

        this.multiFilterDefaultSettings = {
            checkBoxes: true,
            showCheckAll: false,
            showUncheckAll: false,
            smartButtonMaxItems: 3
        };

        this.multiFilter = {
            statuses: {
                model: [],
                options: this.multiFilterOptions.statuses,
                settings: this.multiFilterDefaultSettings
            }
        };
    }

    onPreviouslyCompletedChange () {
        if (!this.filter.previouslyCompleted) {
            delete this.filter.completedVersionId;
        }
    }

    applyFilter () {
        this.filter = this.lodash.assign(this.filter, { 'statuses[]': this.multiFilter.statuses.model.map(status => status.value) });
        this.list.fetch(this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/employee/enrolled/filter/index.js